import React from 'react';

import { Link, useLocation } from 'react-router-dom';
import pageHasMovedImage from 'styles/assets/png/page-has-moved.png';

import classes from 'components/common/ErrorPages/OldLinkNotFound.module.scss';

import { Button } from 'components/DesignSystem/Button';

const oldRouteRedirects = {
    '/dashboard/project/library/': '/dashboard/planning/library/',
    '/dashboard/project/gantt-chart/': '/dashboard/planning/gantt-chart/',
    '/dashboard/program/logicChecker/': '/dashboard/planning/logicChecker/',
    '/dashboard/program/clusterrcfanalysis/': '/dashboard/planning/clusterrcfanalysis/',
    '/dashboard/project/version-compare/': '/dashboard/planning/version-compare/',
    '/dashboard/program/schedule-simulation/': '/dashboard/planning/schedule-simulation/',
    '/dashboard/project/custom-pinboard/': '/dashboard/execution/custom-pinboard/',
    '/dashboard/project/status-summary/': '/dashboard/execution/status-summary/',
    '/dashboard/project/scope-To-Go/': '/dashboard/execution/scope-To-Go/',
    '/dashboard/project/my-focus-page/': '/dashboard/execution/my-focus-page/',
    '/dashboard/project/progress-overview/': '/dashboard/execution/progress-overview/',
    '/dashboard/program/completion-plan/': '/dashboard/execution/completion-plan/',
    '/dashboard/project/data-stories/': '/dashboard/execution/data-stories/',
    '/dashboard/program/risk-register/': '/dashboard/risk/risk-register/',
    '/dashboard/program/kc-recommendations/': '/dashboard/risk/kc-recommendations/',
    '/dashboard/project/critical-analysis/': '/dashboard/risk/critical-analysis/',
    '/dashboard/program/finish-date-prediction/': '/dashboard/risk/finish-date-prediction/',
    '/dashboard/project/productivity/': '/dashboard/risk/productivity/',
    '/dashboard/project/resources-analysis/': '/dashboard/risk/resources-analysis/',
    '/dashboard/project/trend-analysis/': '/dashboard/risk/trend-analysis/',
};

export const OldLinkNotFound = () => {
    const { pathname } = useLocation();

    const newRoute = oldRouteRedirects[pathname] ?? undefined;
    return (
        <div className={classes.message}>
            <div className={classes.oldLinkNotFound}>
                <img className={classes.image} src={pageHasMovedImage} alt={'This page has moved!'} />
                <div className={classes.description}>
                    <h1>This page has moved!</h1>
                </div>
                <p className={classes.text}>
                    We have updated the navigation in Foresight, and this link is no longer valid. <br />
                    Follow the link below to go to the page you were looking for in it’s new home - and remember to
                    update any links or bookmarks.
                </p>
                {newRoute ? (
                    <Button component={Link} variant={'primary'} to={newRoute}>
                        Go to the new page
                    </Button>
                ) : null}
            </div>
        </div>
    );
};
